import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../redux/actions';
import * as appSettingsActions from '../../app-setting/redux/actions';
import * as pluginActions from '../../plugin/redux/actions';
import * as collectionActions from '../../collections/redux/actions';
import CommonPageComponent from '../../../common/ui/CommonPageComponent';
import ParentCardNoCol from '../../common/ParentCardNoCol';
import { Summary } from './Summary';
export class SummaryPage extends Component {
  static propTypes = {
    onBoarding: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const {
      match,
      appSettingsActions: { loadProjectDetailAppSetting },
      pluginActions: { loadAllInstalledPlugin },
      collectionActions: { loadCollectionItems },
    } = this.props;
    const { projectId, version } = match.params;
    loadProjectDetailAppSetting({ projectId, version });
    loadAllInstalledPlugin({ projectId, version });
    loadCollectionItems({ projectId, version, collectionName: 'user' });
  }

  render() {
    const { match, appSetting, plugin, collections } = this.props;
    const { projectId, version } = match.params;
    const { projectDetail } = appSetting;
    const { installedPlugins } = plugin;
    const { items = [] } = collections;

    return (
      <CommonPageComponent>
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
            <ParentCardNoCol icon="on-boarding" title="Summary">
              <div className="center-div">
                <div className="container">
                  <div className="row mx-auto">
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                      <Summary
                        projectId={projectId}
                        version={version}
                        projectDetail={projectDetail}
                        installedPlugins={installedPlugins}
                        items={items}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </ParentCardNoCol>
          </div>
          {/* <ParentDocCard>
            <h5>
              <b>About OnBoarding</b>
            </h5>
            <p>
              Contains all the third-party plugins that allow you to easily integrate additional
              functionalities to your no code/low code web applications.
            </p>
            <br />
            <DocsLink link="" />
          </ParentDocCard> */}
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    onBoarding: state.onBoarding,
    appSetting: state.appSetting,
    plugin: state.plugin,
    collections: state.collections,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    appSettingsActions: bindActionCreators({ ...appSettingsActions }, dispatch),
    pluginActions: bindActionCreators({ ...pluginActions }, dispatch),
    collectionActions: bindActionCreators({ ...collectionActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SummaryPage);
